import React, { useEffect } from 'react'
import CustomTab from '../common/tab'
import './styles.scss'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import Consultations from '@services/Consultations'
import Marketing from '@services/Marketing'
import { CONTENT, FEED } from '@modules/admin/feed/constants'
import { createTitleContentColumns, createTitleFeedsColumns } from '@modules/admin/feed/actions'
import { Panel } from '@modules/admin/feed/Panel.Index'
import { useTranslation } from 'react-i18next'

const FeedContentIndex = () => {
  const markAuth = Marketing.auth.client.defaults.headers.Authorization
  const { t } = useTranslation()
  const tabHeaders = [
    { label: t('feedManageContent'), key: 'manageContent' },
    { label: t('feedManageFeeds'), key: 'manageFeeds' },
  ]

  useEffect(() => {
    if (markAuth === 'Bearer undefined' || markAuth === 'Bearer null') window.location.reload()
  }, [])

  const userGroupsClient = Consultations.userGroups
  const MarketingContent = Marketing.MContent
  const MarketingFeed = Marketing.MFeed

  return (
    <div className="feed-index">
      <DashboardHeader title="Contenido" total={null} />
      <CustomTab headers={tabHeaders}>
        <Panel
          kind={CONTENT}
          className={'content-panel'}
          buttonText={t('feedCreateContent')}
          columns={createTitleContentColumns(t)}
          client={MarketingContent}
          placeholder={t('feedTitleContentOrFeed')}
          nameSearchField="andx:contains:titleAndFeed"
        />
        <Panel
          kind={FEED}
          className={'feed-panel'}
          buttonText={t('feedCreateFeed')}
          columns={createTitleFeedsColumns(t)}
          client={MarketingFeed}
          placeholder={t('feedNameFeedOrGroup')}
          nameSearchField="contains:name"
          groupsClient={userGroupsClient}
        />
      </CustomTab>
    </div>
  )
}
export default FeedContentIndex
